import React from 'react'
import styles from './SkeletonChart.module.scss'

const SkeletonChart = () => {
  return (
    <div className={styles.root}>
      <span></span>
    </div>
  )
}

export default SkeletonChart
